export default __webpack_public_path__ + "static/t-kevin-d17c2ca4b365685182ba7b81510dcc70.png";